const ParentFoodMenu = () => {
  return (
    <section className="ParentFoodMenu w-full h-full bg-red-500">

    </section>
  )
};

export default ParentFoodMenu;